module.exports = __webpack_public_path__ + "static/premios-2-EC-583b108410cc160e568d0ac1d9e4fc75.webp";